<template>

    <div class="invoices">
        <h2>{{ lang('invoices.header') }}</h2>
        <span v-html="lang('invoices.paragraph')"></span>

        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th class="col-2">{{ lang('invoices.invoicenr') }}</th>
                    <th class="col-4">{{ lang('all.datum') }}</th>
                    <th class="text-right">{{ lang('all.totaalbedrag') }}</th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-if="invoices.data.length === 0"
                >
                    <td colspan="4">{{ lang('invoices.no-invoices') }}</td>
                </tr>
                <tr
                    v-for="invoice in invoices.data"
                >
                    <td class="align-middle">#{{ invoice.number }}</td>
                    <td class="align-middle">{{ invoice.date | formatDate }}</td>
                    <td class="align-middle text-right">{{ invoice.totalamount | toCurrency }}</td>
                    <td class="text-right">
                        <a
                            :href="route('auth.myaccount.invoices.download', {uuid: invoice.id})"
                            target="_blank"
                            v-tooltip="lang('invoices.download')"
                            class="btn btn-primary btn-sm mb-0"
                        >
                            <i class="mdi mdi-download"></i>
                            <span class="sr-only">
                                {{ lang('invoices.download') }}
                            </span>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>

        <div
            v-if="invoices.meta && invoices.meta.last_page > 1"
            class="mt-5"
        >
            <pagination
                :meta="invoices.meta"
                :links="invoices.links"
            ></pagination>
        </div>
    </div>

</template>

<script>

import MyAccountLayout from "../../../../Shared/Auth/MyAccount/Layout";
import Pagination from "../../../../components/Pagination.vue";

export default {
    components: {
        Pagination
    },

    layout:MyAccountLayout,

    metaInfo() {
        return {
            title: this.lang('invoices.pagetitle'),
        }
    },

    methods: {
    },

    name:'AuthMyAccountInvoicesIndex',

    props: {
        invoices: {
            required:true,
            type: Object,
        },
    },

}

</script>

<style lang="scss">

span.address-actions {
    display:block;
    margin-top:20px;
}

span.address-actions > .address-action-link {
    display:block;
}

</style>
